import React from 'react';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';

import { useGame } from '../../../../context';
import { getOverallScore } from './selectors';
import TrophyProgressScore from './trophy-score';
import TrophyProgressThumb from './trophy-thumb';
import TrophyProgressTrack from './trophy-track';

const useStyles = createUseStyles({
  bar: {
    composes: ['is-relative', 'no-overflow'],
    height: 40,
    width: 40,
  },
  overall: {
    composes: [
      'text-center',
      'flex-columns',
      'flex-center',
      'items-center',
      'mb24',
    ],
  },
});

const OverallProgressComponent = React.memo(() => {
  const classes = useStyles();
  const { collectibles } = useGame();
  const percentage = useSelector(_ => getOverallScore(_, collectibles));
  const { percent } = percentage;
  return (
    <div className={classes.overall}>
      <div className={classes.bar}>
        <TrophyProgressTrack percent={percent} />
        <TrophyProgressThumb percent={percent} />
      </div>
      <TrophyProgressScore percent={percent} />
    </div>
  );
});

OverallProgressComponent.displayName = 'OverallProgressComponent';

export default OverallProgressComponent;
